import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMyUpcSlips, exportUpcExcel } from "../redux/actions/upcScanActions";
import { formatDbDate } from "../utils/dateFormater";
import Loader from "./loader/loader";
import Img2 from "./images/adjust.png"
import { Link } from "react-router-dom";



const MyUpcScanSlips = () => {
    const dispatch = useDispatch();
    const { loading, slips, totalPages } = useSelector(state => state.myUpcSlips);
    const { loading: exportLoading } = useSelector(
        state => state.exportUpcExcel
    );
    const [page, setPage] = useState(1);

    const [selectedSlips, setSelectedSlips] = useState([]);
    const [selectedSlipMap, setSelectedSlipMap] = useState({});
    const [showFilters, setShowFilters] = useState(false)
    const [filterCount, setFilterCount] = useState(0)
    const [status, setstatus] = useState('')
    const [date_before, setDate_before] = useState("");
    const [date_after, setDate_after] = useState("");



    useEffect(() => {

        const query = {}
        if (status) query.status = status;
        if (date_before) query.date_before = date_before;
        if (date_after) query.date_after = date_after;


        dispatch(getMyUpcSlips(page, query));
    }, [dispatch, page, status, date_before, date_after]);

    const toggleSlip = (slip) => {
        setSelectedSlips(prev =>
            prev.includes(slip.slipId)
                ? prev.filter(id => id !== slip.slipId)
                : [...prev, slip.slipId]
        );

        setSelectedSlipMap(prev => {
            const copy = { ...prev };

            if (copy[slip.slipId]) {
                delete copy[slip.slipId];   // unselect
            } else {
                copy[slip.slipId] = slip;  // cache slip data
            }

            return copy;
        });
    };


    const mergedExportData = () => {
        const map = {};

        Object.values(selectedSlipMap).forEach(slip => {
            slip.items.forEach(item => {
                if (!map[item.upc]) map[item.upc] = 0;
                map[item.upc] += item.quantity;
            });
        });

        return Object.entries(map).map(([upc, quantity]) => ({
            upc,
            quantity
        }));
    };




    useEffect(() => {
        const Headerlinkks = document.querySelectorAll(".headerLinks");
        const element = document.getElementById("UpcScanSlip");

        Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
        element?.classList.add("activeHeaderLink");

        document.title = `UPC Scans - Admin Panel`;

    }, []);



    const handleExport = () => {
        dispatch(exportUpcExcel(selectedSlips));
        dispatch(getMyUpcSlips(page));
    };




    useEffect(() => {
        let count = 0;

        if (status) count++;
        if (date_before) count++;
        if (date_after) count++;

        setFilterCount(count);
    }, [status, date_before, date_after]);


    const getTotalQuantity = (items = []) => {
  return items.reduce((total, item) => {
    return total + Number(item.quantity || 0);
  }, 0);
};


    return (
        <Fragment>
            {loading && <Loader />}
            <section className="pl-[1.5vmax] pr-[2.5vmax]">
                <div className="flex justify-between items-center bg-white p-[1.2vmax] rounded-[1vmax] px-[2vmax]">
                    <h2 className="text-[1.3vmax] font-bold">UPC Scans</h2>

                    <div className="flex-center gap-[0.8vmax] text-[1vmax]">
                        <Link to={"/"}>Dashboard</Link>
                        <div className="w-[0.3vmax] h-[0.3vmax] rounded-[50%] bg-black"></div>
                        <span className="text-slate-400">UPC Scans</span>
                    </div>
                </div>
            </section>
            <div className="flex justify-end my-5 pr-[2.5vmax]" >
                <button className="flex-center font-bold py-[0.6vmax] px-[1.5vmax] bg-[image:var(--gradient)] gap-[1vmax] rounded-[2vmax] text-white relative"
                    onClick={() => setShowFilters(true)}
                >
                    <span className='absolute  top-[-0.5vmax] left-0 py-[0.1vmax] px-[0.4vmax] bg-white text-[var(--color-2)] rounded-[50%] shadow-1 ' >{filterCount}</span>
                    <img src={Img2} alt="" className='w-[1.5vmax]' />
                    <span>Filters</span>
                </button>
            </div>
            {showFilters &&
                <section className='pl-[1.5vmax] pr-[1.5vmax] lg:pr-[2.5vmax]' >
                    <div className="bg-white shadow-1 pb-[2vmax] px-[2vmax] rounded-[1vmax] mt-[2vmax]">
                        <div className="border-b-[0.15vmax] pt-[1.5vmax] pb-[1vmax] font-bold flex justify-between">
                            <h3 className='' >Filters</h3>
                            <button onClick={() => setShowFilters(false)} >
                                <i className="fa-solid fa-xmark text-[1.5vmax]"></i>
                            </button>
                        </div>
                        <div className="flex justify-between flex-wrap">
                            <div className={`flex my-[1vmax] w-full lg:w-[31.5%] border-[0.15vmax] h-fit items-center  outline-blue-400 rounded-[2vmax] ${date_after ? 'border-[var(--color-2)] bg-blue-50' : ''}`}>
                                <div className='w-[25%] bg-[image:var(--gradient)] rounded-l-[2vmax] font-bold text-white py-[0.75vmax] pl-[1vmax] ' >From :</div>
                                <div className={`relative ${date_after ? 'w-[61%]' : 'w-[80%]'}`} >
                                    <input
                                        type='date'
                                        value={date_after}
                                        onChange={(e) => {
                                            setDate_after(e.target.value)
                                        }}
                                        className=' px-[2vmax] py-[0.7vmax]  w-full pr-[2vmax] outline-none rounded-[2vmax] bg-transparent'
                                    />
                                </div>
                                {date_after &&
                                    <button className="w-[14%] h-fit text-[1.5vmax] text-gray-700 border-l-[0.2vmax]"
                                        onClick={() => setDate_after('')}
                                    >
                                        <i className="fa-solid fa-xmark"></i>
                                    </button>
                                }
                            </div>

                            <div className={`flex my-[1vmax] w-full lg:w-[31.5%] border-[0.15vmax] h-fit items-center  outline-blue-400 rounded-[2vmax] ${date_before ? 'border-[var(--color-2)] bg-blue-50' : ''}`}>
                                <div className='w-[20%] bg-[image:var(--gradient)] rounded-l-[2vmax] font-bold text-white py-[0.75vmax] pl-[1vmax] ' >To :</div>
                                <div className={`relative ${date_before ? 'w-[66%]' : 'w-[75%]'}`} >
                                    <input
                                        type='date'
                                        value={date_before}
                                        onChange={(e) => {
                                            setDate_before(e.target.value)
                                        }}
                                        className=' px-[2vmax] py-[0.7vmax]  w-full outline-none rounded-[2vmax] bg-transparent'
                                    />
                                </div>
                                {date_before &&
                                    <button className="w-[14%] h-fit text-[1.5vmax] text-gray-700 border-l-[0.2vmax]"
                                        onClick={() => setDate_before('')}
                                    >
                                        <i className="fa-solid fa-xmark"></i>
                                    </button>
                                }
                            </div>

                            <div className={`flex my-[1vmax] w-full lg:w-[31.5%] border-[0.15vmax] h-fit items-center  outline-blue-400 rounded-[2vmax] ${status ? 'border-[var(--color-2)] bg-blue-50' : ''}`}>
                                <div className={`relative ${status ? 'w-[86%]' : 'w-[100%] pr-[1vmax]'}`} >
                                    <select
                                        value={status}
                                        onChange={(e) => {
                                            setPage(1)
                                            setstatus(e.target.value)
                                        }}
                                        className='px-[2vmax] py-[0.7vmax]  w-full pr-[4vmax] outline-none rounded-[2vmax] bg-transparent'
                                    >
                                        <option value="">Filter by Status</option>
                                        <option value="1">Exported</option>
                                        <option value="0">Not-Exported</option>
                                    </select>
                                </div>
                                {status &&
                                    <button className="w-[14%] h-fit text-[1.5vmax] text-gray-700 border-l-[0.2vmax]"
                                        onClick={() => setstatus('')}
                                    >
                                        <i className="fa-solid fa-xmark"></i>
                                    </button>

                                }
                            </div>

                        </div>
                    </div>
                </section>
            }
            <div className="p-6  mx-auto">
                {slips?.length > 0 ? slips?.map((slip, index) => (
                    <div
                        key={slip.slipId}
                        className="border rounded-2xl p-4 mb-4 bg-white shadow-1"
                    >
                        <div className="flex items-center justify-between mb-3">
                            <div>
                                <span></span>

                            </div>

                            <input
                                type="checkbox"
                                className="w-5 h-5 accent-blue-600"
                                checked={selectedSlips.includes(slip.slipId)}
                                onChange={() => toggleSlip(slip)}

                            />
                        </div>

                        {slip?.items.length > 0 &&
                            <div className="space-y-2">
                                {slip.items.length === 1 ? slip.items.map(item => (


                                    <div
                                        key={item.upc}
                                    >
                                        <div className="flex justify-between text-sm bg-gray-200 p-2 rounded text-[14px] px-[20px] font-bold">
                                            <span>Product UPC</span>
                                            <span>Quantity</span>
                                        </div>
                                        <div
                                            className="flex justify-between text-sm  p-[0px_20px]  border-[1px] border-gray-200"
                                        >
                                            <span className="font-mono  w-1/2 border-r-[1px] border-gray-200 py-[8px]">{item.upc}</span>
                                            <span className="text-[16px]  w-1/2  py-[8px] text-right font-bold text-[var(--color-2)]">
                                                {item.quantity}
                                            </span>

                                        </div>
                                    </div>
                                ))
                                    :
                                    <>
                                        <div className="flex justify-between items-center">
                                            <div className="flex justify-between text-sm bg-gray-200 p-2 rounded text-[14px] px-[20px] font-bold w-full lg:w-[49.5%]">
                                                <span>Product UPC</span>
                                                <span>Quantity</span>
                                            </div>
                                            <div className="hidden lg:flex justify-between text-sm bg-gray-200 p-2 rounded text-[14px] px-[20px] font-bold w-[49.5%]">
                                                <span>Product UPC</span>
                                                <span>Quantity</span>
                                            </div>
                                        </div>
                                        <div
                                            className="flex justify-between items-center flex-wrap"
                                        >
                                            {slip.items.map(item => (
                                                <div
                                                    className="flex justify-between text-sm  p-[0px_20px]  border-[1px] border-gray-200 w-full lg:w-[49.5%]"
                                                    key={item.upc}

                                                >
                                                    <span className="font-mono  w-1/2 border-r-[1px] border-gray-200 py-[8px]">{item.upc}</span>
                                                    <span className="text-[16px]  w-1/2  py-[8px] text-right font-bold text-[var(--color-2)]">
                                                        {item.quantity}
                                                    </span>

                                                </div>
                                            ))}
                                        </div>

                                    </>

                                }
                                <div className="text-right mt-[0.5vmax] text-[1vmax] font-bold">
                                    Total Quantity : <span className="text-blue-500" >{getTotalQuantity(slip.items)}</span>
                                </div>
                            </div>

                        }
                        {
                            slip?.wrongScans.length > 0 &&
                            <div className="space-y-2">
                                {slip.wrongScans.length === 1 ? slip.wrongScans.map(item => (

                                    <div
                                        key={item.upc}
                                    >
                                        <h3 className="mt-[1vmax] mb-[0.5vmax] font-bold text-red-500 text-center w-fit mx-auto bg-red-100 p-[0.3vmax_1vmax] rounded-full "  >
                                            <i className="fa-regular fa-xmark-circle"></i>
                                            &nbsp;&nbsp;
                                            Invalid Scans</h3>
                                        <div className="flex justify-between text-sm bg-red-100 text-red-600 p-2 rounded text-[14px] px-[20px] font-bold">
                                            <span>Product UPC</span>
                                            <span>Quantity</span>
                                        </div>
                                        <div
                                            className="flex justify-between text-sm  p-[0px_20px]  border-[1px] border-gray-200"
                                        >
                                            <span className="font-mono  w-1/2 border-r-[1px] border-gray-200 py-[8px]">{item.upc}</span>
                                            <span className="text-[16px]  w-1/2  py-[8px] text-right font-bold text-red-500">
                                                {item.quantity}
                                            </span>

                                        </div>
                                    </div>
                                ))
                                    :
                                    <>
                                        <h3 className="mt-[1vmax] mb-[0.5vmax] font-bold text-red-500 text-center w-fit mx-auto bg-red-100 p-[0.3vmax_1vmax] rounded-full "  >
                                            <i className="fa-regular fa-xmark-circle"></i>
                                            &nbsp;&nbsp;
                                            Invalid Scans</h3>
                                        <div className="flex justify-between items-center">
                                            <div className="flex justify-between text-sm bg-red-100 text-red-600 p-2 rounded text-[14px] px-[20px] font-bold w-full lg:w-[49.5%]">
                                                <span>Product UPC</span>
                                                <span>Quantity</span>
                                            </div>
                                            <div className="hidden lg:flex justify-between text-sm bg-red-100 text-red-600 p-2 rounded text-[14px] px-[20px] font-bold w-[49.5%]">
                                                <span>Product UPC</span>
                                                <span>Quantity</span>
                                            </div>
                                        </div>
                                        <div
                                            className="flex justify-between items-center flex-wrap"
                                        >
                                            {slip.wrongScans.map(item => (
                                                <div
                                                    className="flex justify-between text-sm  p-[0px_20px]  border-[1px] border-gray-200 w-full lg:w-[49.5%]"
                                                    key={item.upc}

                                                >
                                                    <span className="font-mono  w-1/2 border-r-[1px] border-gray-200 py-[8px]">{item.upc}</span>
                                                    <span className="text-[16px]  w-1/2  py-[8px] text-right font-bold text-red-600">
                                                        {item.quantity}
                                                    </span>

                                                </div>
                                            ))}
                                        </div>

                                    </>

                                }
                                 <div className="text-right mt-[0.5vmax] text-[1vmax] font-bold">
                                    Total Quantity : <span className="text-red-500" >{getTotalQuantity(slip.wrongScans)}</span>
                                </div>
                            </div>
                        }
                        <div className="flex justify-between mt-2">
                            <div className="flex items-center gap-5" >
                                {slip.status === 1 ?
                                    <div className="bg-green-700 text-[12px] text-white p-[2px_8px] rounded" >
                                        Exported
                                    </div>
                                    :
                                    <div className="bg-red-700 text-[12px] text-white p-[2px_8px] rounded" >
                                        Not-Exported
                                    </div>
                                }
                            </div>
                            <p className="text-[12px] italic text-gray-500 text-right mt-3">
                                {formatDbDate(slip.createdAt)}
                            </p>
                        </div>
                    </div>
                ))
                    :
                    <p className="text-center text-gray-500 mt-10">No inventory slips found.</p>
                }



                {
                    selectedSlips.length > 0 && (
                        <div className="mt-6 p-4 border rounded-2xl bg-white shadow-1">
                            <p className="font-semibold text-center mb-5">
                                Export Preview (Merged)
                            </p>
                            <div className="flex text-[14px] font-bold">
                                <div className="w-[30%] lg:w-[10%] border-[1px] border-gray-300 py-1 text-center ">Quantity</div>
                                <div className="w-[40%] lg:w-[10%] border-[1px] border-gray-300 py-1 text-center ">UPC</div>
                                <div className="w-[30%] lg:w-[20%] border-[1px] border-gray-300 py-1 text-center ">Time</div>
                                <div className="w-[10%] border-[1px] border-gray-300 py-1 text-center hidden lg:block"></div>
                                <div className="w-[10%] border-[1px] border-gray-300 py-1 text-center hidden lg:block "></div>
                                <div className="w-[10%] border-[1px] border-gray-300 py-1 text-center hidden lg:block"></div>
                                <div className="w-[10%] border-[1px] border-gray-300 py-1 text-center hidden lg:block "></div>
                                <div className="w-[10%] border-[1px] border-gray-300 py-1 text-center hidden lg:block"></div>
                                <div className="w-[20%] lg:w-[10%] border-[1px] border-gray-300 py-1 text-center hidden lg:block"></div>
                                <div className="w-[20%] lg:w-[10%] border-[1px] border-gray-300 py-1 text-center hidden lg:block"></div>
                            </div>
                            {mergedExportData().map(item => (

                                <div
                                    key={item.upc}
                                    className="flex text-[13px] "

                                >
                                    <span className="w-[30%] lg:w-[10%] border-[1px] border-gray-300 py-1 text-center">{item.quantity}</span>
                                    <span className="w-[40%] lg:w-[10%] border-[1px] border-gray-300 py-1 text-center">{item.upc}</span>
                                    <div className="w-[30%] lg:w-[20%] border-[1px] border-gray-300 py-1 text-center ">Export Time</div>
                                    <div className="w-[10%] border-[1px] border-gray-300 py-1 text-center hidden lg:block"></div>
                                    <div className="w-[10%] border-[1px] border-gray-300 py-1 text-center hidden lg:block "></div>
                                    <div className="w-[10%] border-[1px] border-gray-300 py-1 text-center hidden lg:block"></div>
                                    <div className="w-[10%] border-[1px] border-gray-300 py-1 text-center hidden lg:block"></div>
                                    <div className="w-[10%] border-[1px] border-gray-300 py-1 text-center hidden lg:block"></div>
                                    <div className="w-[10%] border-[1px] border-gray-300 py-1 text-center hidden lg:block"></div>
                                    <div className="w-[10%] border-[1px] border-gray-300 py-1 text-center hidden lg:block"></div>
                                </div>
                            ))}

                            <div className="text-right mt-4" >

                                <button
                                    onClick={() => {
                                        setSelectedSlips([]);
                                        setSelectedSlipMap({});
                                    }}

                                    className="mt-4 px-4 py-2 bg-gray-200  rounded"
                                >
                                    Cancel Export
                                </button>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <button
                                    onClick={handleExport}
                                    disabled={exportLoading}
                                    className="mt-4 px-4 py-2 bg-green-600 text-white rounded"
                                >
                                    {exportLoading ? "Exporting..." : "Export Selected Slips"}
                                </button>

                            </div>
                        </div>
                    )
                }
            </div >
            {totalPages > 1 && (
                <div className="flex gap-[1vmax] justify-center mt-[2vmax]">

                    {/* Prev button */}
                    <button
                        className="pagination-btn"
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Prev
                    </button>

                    {/* --- SMART PAGINATION START --- */}
                    {(() => {
                        const pages = [];
                        const maxVisible = 3; // number of pages to show around current page

                        const addPage = (p) => {
                            pages.push(
                                <button
                                    key={p}
                                    className={`pagination-btn ${page === p ? "active" : ""}`}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </button>
                            );
                        };

                        // Always show First Page
                        addPage(1);

                        // Left dots
                        if (page > maxVisible + 2) {
                            pages.push(<span key="dots-left">...</span>);
                        }

                        // Middle pages (dynamic)
                        for (
                            let p = Math.max(2, page - maxVisible);
                            p <= Math.min(totalPages - 1, page + maxVisible);
                            p++
                        ) {
                            addPage(p);
                        }

                        // Right dots
                        if (page < totalPages - (maxVisible + 1)) {
                            pages.push(<span key="dots-right">...</span>);
                        }

                        // Always show Last Page
                        if (totalPages > 1) {
                            addPage(totalPages);
                        }

                        return pages;
                    })()}
                    {/* --- SMART PAGINATION END --- */}

                    {/* Next button */}
                    <button
                        className="pagination-btn"
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>

                </div>

            )}
            <br />
            <br />
            <br />
        </Fragment>
    );
};

export default MyUpcScanSlips;
